var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "none", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.useFlagItems,
                    itemText: "codeName",
                    itemValue: "code",
                    name: "useFlag",
                    label: "사용여부",
                  },
                  model: {
                    value: _vm.searchParam.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "useFlag", $$v)
                    },
                    expression: "searchParam.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c(
              "c-tree-table",
              {
                attrs: {
                  title: "설비유형 목록",
                  parentProperty: "upEquipmentTypeCd",
                  customID: "equipmentTypeCd",
                  columns: _vm.gridClass.columns,
                  data: _vm.gridClass.data,
                  columnSetting: false,
                  isFullScreen: false,
                  usePaging: false,
                  expandAll: true,
                },
                on: { rowClick: _vm.rowClick },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: { label: "검색", icon: "search" },
                          on: { btnClicked: _vm.getList },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c(
              "q-form",
              { ref: "editForm" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "설비유형 상세정보" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: { label: "신규", icon: "add" },
                                  on: { btnClicked: _vm.addClass },
                                })
                              : _vm._e(),
                            _vm.editable && _vm.saveable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.equipClassData,
                                    mappingType: _vm.saveType,
                                    label: "저장",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveClass,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: "",
                              editable:
                                _vm.editable &&
                                _vm.dataeditable &&
                                !_vm.disabled,
                              label: "설비유형 명칭",
                              name: "equipmentTypeName",
                            },
                            model: {
                              value: _vm.equipClassData.equipmentTypeName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.equipClassData,
                                  "equipmentTypeName",
                                  $$v
                                )
                              },
                              expression: "equipClassData.equipmentTypeName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: "",
                              editable:
                                _vm.editable &&
                                _vm.dataeditable &&
                                !_vm.disabled,
                              disabled: _vm.updateMode,
                              label: "설비유형 코드",
                              name: "equipmentTypeCd",
                            },
                            model: {
                              value: _vm.equipClassData.equipmentTypeCd,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.equipClassData,
                                  "equipmentTypeCd",
                                  $$v
                                )
                              },
                              expression: "equipClassData.equipmentTypeCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-select", {
                            attrs: {
                              required: "",
                              editable:
                                _vm.editable &&
                                _vm.dataeditable &&
                                !_vm.disabled,
                              comboItems: _vm.typeCdItems,
                              typetxt: "해당없음",
                              type: "custom",
                              itemText: "codeName",
                              itemValue: "code",
                              label: "생산설비/유틸리티",
                              name: "upEquipmentTypeCd",
                            },
                            model: {
                              value: _vm.equipClassData.upEquipmentTypeCd,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.equipClassData,
                                  "upEquipmentTypeCd",
                                  $$v
                                )
                              },
                              expression: "equipClassData.upEquipmentTypeCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: "",
                              type: "edit",
                              disabled: _vm.updateMode,
                              editable:
                                _vm.editable &&
                                _vm.dataeditable &&
                                !_vm.disabled,
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.equipClassData.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.equipClassData, "plantCd", $$v)
                              },
                              expression: "equipClassData.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable && !_vm.disabled,
                              isFlag: true,
                              label: "일상점검 대상",
                              name: "dailyFlag",
                            },
                            model: {
                              value: _vm.equipClassData.dailyFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.equipClassData, "dailyFlag", $$v)
                              },
                              expression: "equipClassData.dailyFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable && !_vm.disabled,
                              isFlag: true,
                              label: "열화관리점검 대상",
                              name: "deteriorFlag",
                            },
                            model: {
                              value: _vm.equipClassData.deteriorFlag,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.equipClassData,
                                  "deteriorFlag",
                                  $$v
                                )
                              },
                              expression: "equipClassData.deteriorFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable:
                                _vm.editable &&
                                _vm.dataeditable &&
                                !_vm.disabled,
                              isFlag: true,
                              label: "사용여부",
                              name: "useFlag",
                            },
                            model: {
                              value: _vm.equipClassData.useFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.equipClassData, "useFlag", $$v)
                              },
                              expression: "equipClassData.useFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("c-textarea", {
                            attrs: {
                              counter: true,
                              maxlength: 200,
                              editable: _vm.editable && _vm.dataeditable,
                              rows: 5,
                              label: "비고",
                              name: "remarks",
                            },
                            model: {
                              value: _vm.equipClassData.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.equipClassData, "remarks", $$v)
                              },
                              expression: "equipClassData.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }